import {API_URL} from "@/lib/constants";
import {Session, UploadResponse} from "@/lib/types";

export async function fetchBackend<T>(url: string,
                                      method: "GET" | "POST" | "PATCH",
                                      session?: Session | null,
                                      payload?: any,
): Promise<T> {
    let headers: HeadersInit = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    if (session) {
        headers.Authorization = `Bearer ${session.session_id}`;
    }

    const response = await fetch(API_URL + url, {
        method: method,
        body: payload ? JSON.stringify(payload) : undefined,
        headers,
    });

    if (response.ok) {
        return await response.json();
    } else {
        throw await response.json();
    }
}

export async function fetchBackendURLParams<T>(url: string,
                                               method: "GET" | "POST" | "PATCH",
                                               payload: URLSearchParams,
                                               session?: Session | null,
): Promise<T> {
    let headers: HeadersInit = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    if (session) {
        headers.Authorization = `Bearer ${session.session_id}`;
    }

    const response = await fetch(API_URL + url + '?' + payload.toString(), {
        method: method,
        headers,
    });

    if (response.ok) {
        return await response.json();
    } else {
        throw await response.json();
    }
}

export async function fetchBackendNoContent(url: string,
                                            method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
                                            session?: Session | null,
                                            payload?: any,
): Promise<void> {
    let headers: HeadersInit = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    if (session) {
        headers.Authorization = `Bearer ${session.session_id}`;
    }

    const response = await fetch(API_URL + url, {
        method: method,
        body: payload ? JSON.stringify(payload) : undefined,
        headers,
    });

    if (!response.ok) {
        throw await response.json();
    }
}

export async function uploadPicture(file: File | Uint8Array<ArrayBuffer>, session: Session): Promise<UploadResponse> {
    let headers: HeadersInit = {
        Accept: 'application/json',
        Authorization: `Bearer ${session.session_id}`,
        'Content-Type': 'application/octet-stream',
    };

    const response = await fetch(API_URL + "/picture", {
        method: "POST",
        body: file,
        headers,
    });

    if (response.ok) {
        return await response.json();
    } else {
        throw await response.json();
    }
}

// Return true if the request should retry.
export function dataRetryPolicy(_failureCount: number, error: Error) {
    return error.name !== "ApiError"
}